import numeral from 'numeral'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components/macro'

import { Tag } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { useWindowWidth } from 'core/ui/hooks/useWindowWidth'

import { intSizes } from 'legacy/styles/screen'

const Wrapper = styled(Tag)`
  white-space: nowrap;
  ${({ darkThemed }) =>
    darkThemed &&
    css`
      color: ${getToken('color-neutral-white')};

      background-color: ${getToken('color-neutral-dark')};
    `};
`

function presentDistance({ isExtraSmallScreen, isSmallScreen }) {
  if (isExtraSmallScreen) return ''
  if (isSmallScreen) return 'Dist'

  return 'Distance'
}

function defaultFormatter({ isExtraSmallScreen, isSmallScreen, mileage }) {
  const formattedTotalDistance = numeral(mileage).format('0,0')
  return `${presentDistance({ isExtraSmallScreen, isSmallScreen })} ${formattedTotalDistance} mi`
}

function Mileage(props) {
  const { mileage, darkThemed, forceMobile, formatter, ...rest } = props
  const windowWidth = useWindowWidth()
  const isSmallScreen = forceMobile || windowWidth <= intSizes.md
  const isExtraSmallScreen = windowWidth <= 400

  return (
    <Wrapper size="small" variant="default" darkThemed={darkThemed} {...rest}>
      {formatter({ isSmallScreen, isExtraSmallScreen, mileage })}
    </Wrapper>
  )
}

Mileage.propTypes = {
  mileage: PropTypes.node.isRequired,
  darkThemed: PropTypes.bool,
  forceMobile: PropTypes.bool,
  formatter: PropTypes.func,
}

Mileage.defaultProps = {
  darkThemed: false,
  forceMobile: false,
  formatter: defaultFormatter,
}

export { Mileage }
